import React, { Fragment, useContext, useState, useEffect } from "react";
import UserContext from "../contexts/user-context";
import { preSignin, signin, resendCode } from "../api/userApi";
import Modal from "react-modal";
import { customStyles } from "../css/modal-style";
import MaskedInput from "react-text-mask";
import ReactInputVerificationCode from "react-input-verification-code";
import CountDown from "../Shared/CountDown";
import LoadingContext from "../contexts/loading-context";
import ErrorContext from "../contexts/error-context";

export default function SignIn2(props) {
  const { isVisible, setVisible, setSignUp } = props;
  const { user, handleUserSignIn } = useContext(UserContext);
  const { setIsLoading } = useContext(LoadingContext);
  const { showErrorModal } = useContext(ErrorContext);

  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [codeId, setCodeId] = useState("");
  const [isTimeUp, setTimeUp] = useState(false);

  const [error, setError] = useState("");
  const [state, setState] = useState(1);

  async function getCode(e) {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    const trimmedPhone = phone.replace(/[^\d]/g, "");
    await preSignin(trimmedPhone)
      .then((res) => {
        setIsLoading(false);

        if (res.data.success) {
          setCodeId(res.data.data);
          setState(2);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err.response);
        if (err.response && err.response.status === 401) {
          setError("There is no account associated with this phone number.");
        } else {
          setError(
            "There is an error. Please refresh and try again or Contact us"
          );
        }
      });
  }

  async function signIn(e) {
    e.preventDefault();
    const trimmedPhone = phone.replace(/[^\d]/g, "");

    const payload = {
      phone: trimmedPhone,
      code,
      codeId,
    };

    await signin(payload)
      .then(async (res) => {
        // setLoading(false);
        console.log("sign in success", res.data);
        //api returns w userprofile
        handleUserSignIn(res.data);
        reset();
        setVisible(false);
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err.response);
        if (err.response && err.response.status === 401) {
          setError("Authentication Code is incorrect. Please try again.");
        } else {
          setError(
            "There is an error. Please refresh and try again or Contact us"
          );
        }
      });
  }

  function close() {
    reset();
    setVisible(false);
  }

  async function resend(e) {
    e.preventDefault();
    setTimeUp(false);
    const trimmedPhone = phone.replace(/[^\d]/g, "");

    await resendCode(trimmedPhone).then((res) => {
      if (res.data.success) {
        setCodeId(res.data.data);
      }
    });
  }

  function reset() {
    setCode("");
    setPhone("");
    setCodeId("");
    setTimeUp(false);
    setError("");
  }

  return (
    <div
      style={{ height: "100vh", padding: "10px" }}
      // className="d-flex flex-column justify-content-center align-items-center"
    >
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6 d-flex flex-row">
          <img
            className="d-none d-lg-block"
            src="/mockup (1).png"
            height="400px"
            style={{ marginBottom: 20, marginRight: -50 }}
          />
          <img
            className="d-none d-md-block "
            src="/mockup (2).png"
            height="400px"
            style={{ zIndex: 1 }}
          />
          <img
            className="d-none d-md-block"
            src="/mockup (3).png"
            height="400px"
            style={{ marginBottom: 20, marginLeft: -50 }}
          />
        </div>
        <div
          className="col-md-4 p-3"
          style={{ backgroundColor: "white", borderRadius: 20 }}
        >
          <h3>Welcome back</h3>
          {state == 1 && (
            <ScreenOne
              getCode={getCode}
              phone={phone}
              setPhone={setPhone}
              error={error}
            />
          )}
          {state == 2 && (
            <ScreenTwo
              code={code}
              setCode={setCode}
              signIn={signIn}
              phone={phone}
              error={error}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function ScreenOne(props) {
  const { getCode, setPhone, phone, error } = props;
  return (
    <Fragment>
      {" "}
      <div style={{ marginBottom: 10 }}>
        <label htmlFor="exampleInputEmail1">Enter your phone number</label>
        <MaskedInput
          mask={[
            "(",
            /[1-9]/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ]}
          className="form-control"
          placeholder="Enter your phone number"
          guide={false}
          id="phone=number"
          // onBlur={() => {}}
          onChange={(e) => {
            setPhone(e.target.value);
          }}
          value={phone}
        />
        {error != "" && <div className="text-danger mb-1">{error}</div>}
      </div>
      <button
        type="submit"
        className="btn btn-success"
        onClick={getCode}
        disabled={phone === ""}
      >
        Send verification code
      </button>
      <div className="mt-3 text-secondary ">
        Need an account?{" "}
        <a href="http://squishalert.com/" style={{ color: "#6c757d" }}>
          <b>Download our mobile app</b>
        </a>
      </div>
    </Fragment>
  );
}
function ScreenTwo(props) {
  const { code, setCode, signIn, phone, error } = props;
  return (
    <Fragment>
      <div className="verification-code" style={{ marginBottom: 10 }}>
        <p>
          {" "}
          Please enter the verification code we just sent to your phone number{" "}
          {phone}
        </p>
        <ReactInputVerificationCode
          length={6}
          onChange={setCode}
          value={code}
        />
        {error != "" && <div className="text-danger mb-1">{error}</div>}
      </div>
      <button
        type="submit"
        className="btn btn-success"
        onClick={signIn}
        disabled={phone === "" || code === ""}
      >
        Verify and Sign in
      </button>
    </Fragment>
  );
}
